<nes-selectable-radio
  [checked]="isSelected"
  nes-id=""
  label=""
  filled="false"
  (nesOnClick)="selectProduct()"
>
  <div slot="header">
    <div class="product-card-header">
      <div class="product-title-col">
        <nes-sticker
          *ngIf="product.hasSticker"
          type="highlight"
          [filled]="false"
          [compact]="false"
          class="product-sticker"
        >
          {{ "COMPOSE.PRODUCTS_OVERVIEW.MOST_CHOSEN" | translate }}
        </nes-sticker>
        <nes-heading tag="h3" size="2xl"><span class="product-heading">{{
          "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + product.identifier + ".TITLE"
            | translate
        }}</span></nes-heading>
        <div class="nes-text-default">
          {{
            "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + product.identifier + ".SUBTEXT"
              | translate
          }}
        </div>
      </div>

      <div class="product-price-col">
        <div class="nes-flex nes-flex-col nes-items-end">
          <ng-container
            *ngIf="
              product.identifier === ProductIdentifier.Traject &&
                !configuredProduct;
              else price
            "
          >
            <nes-text
              class="nes-wrap nes-mt-2"
              tag="span"
              weight="bold"
              [size]="{ xs: 'sm' }"
              color="text-heading"
              style="font-size: 14px;"
            >
              {{
                "COMPOSE.PRODUCTS_OVERVIEW.READ_MORE.PRICE_CATEGORY_TRAJECT"
                  | translate
              }}</nes-text
            >
          </ng-container>
          <ng-template #price>
            <nes-price
              [price]="
                configuredProduct
                  ? configuredProduct.price / 100
                  : product.price / 100
              "
              size="xl"
            >
            </nes-price>
            <nes-text
              class="nes-wrap nes-text-right"
              tag="span"
              [size]="{ xs: 'sm' }"
              color="text-heading"              style="font-size: 14px;"            >
              {{
                'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' +
                  product.identifier +
                  '.PRICE_CATEGORY' | translate
              }}
            </nes-text>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div
    slot="content"
    *ngIf="
      'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.PROPS'
        | translate as properties
    "
  >
    <nes-text-list
      class="nes-mb-5"
      list-type="checked"
      size="base"
      color="text-body"
    >
      <nes-text-list-item *ngFor="let prop of properties">{{
        prop
      }}</nes-text-list-item>
    </nes-text-list>

    <div *ngIf="configuredProduct?.route as route">
      <div
        class="route--container"
        [cypress]="'configured_product'"
        (click)="!routeLoading && chooseRoute.emit()"
      >
        <div class="route-column mt-1">
          <div *ngIf="route.from as from" class="route-row">
            <div class="route-dot"></div>
            <div class="route-line-down"></div>
            <div class="route-data">
              <strong>{{ from.naam }}</strong>
            </div>
          </div>
          <div *ngIf="route.to as to" class="route-row mt-1 mb-1">
            <div class="route-dot"></div>
            <div class="route-line-up"></div>
            <div class="route-data">
              <strong>{{ to.naam }}</strong>
            </div>
          </div>
        </div>
        <div
          *ngIf="routeLoading; else editIcon"
          class="basicLoader nes-self-center"
        ></div>
        <ng-template #editIcon>
          <div class="route-icon">
            <i class="icon edit--small"></i>
          </div>
        </ng-template>
      </div>
    </div>

    @if (product.identifier === "VRIJ") {
      <nes-highlight-box>
        <p
          [innerHTML]="
            'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.VRIJ.PHASE_OUT_NOTIFICATION'
              | translate
          "
        ></p>
      </nes-highlight-box>
    }

    <div class="nes-mt-3" (click)="$event.stopPropagation(); $event.preventDefault()">
      <nes-link
        (nesOnClick)="emitReadMore(product)"
        [cypress]="'read_more'"
        [size]="'sm'"
      >
        {{
          "COMPOSE.PRODUCTS_OVERVIEW.READ_MORE." + product.identifier + ".LINK"
            | translate
        }}
      </nes-link>
    </div>
  </div>
</nes-selectable-radio>
